export default __webpack_public_path__ + "static/media/ico_app.47c904e1.svg";